import type { Epic } from 'Flux/index.js'
import { invitationSlice } from 'Flux/Slice/Invitation/InvitationSlice.js'
import { InviteRepository } from 'Repository/index.js'
import { filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const SaveNewOrderCompletedNotificationEpic: Epic = (action$, state$, { [invitationSlice.name]: invites }) =>
  action$.pipe(
    filter(invites.saveNewOrderCompletedNotificationRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) =>
      InviteRepository.saveNewOrderCompletedNotification(action.payload).pipe(
        mergeMap((response) => of(invites.saveNewOrderCompletedNotificationRequestSuccess(response)))
      )
    )
  )
